import Odd from '@core/models/offer/Odd';

export interface PriceBoostOdd extends Odd {
    team1: string;
    team2: string;
    tournament: string;
    matchDate: string;
    eventId: number;
}

export const HomePagePriceBoostPosition = {
    AboveMatchCombos: 'above_match_combos',
    AboveLiveSection: 'above_live_section',
} as const;
